import React, { useState, useEffect } from 'react';
import { Card, Row, Col, Button, ListGroup, Badge, Spinner } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { getUserProfile } from '../../services/userService';
import { getShopByOwner, getShopOrders } from '../../services/shopService';

const SellerPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { currentUser, loading: authLoading } = useAuth();
  const [userProfile, setUserProfile] = useState(null);
  const [newOrdersCount, setNewOrdersCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadUserData = async () => {
      if (currentUser) {
        try {
          setLoading(true);
          const profile = await getUserProfile(currentUser.uid);
          setUserProfile(profile);

          // Verifica se l'utente è un seller
          if (!profile?.role || profile.role !== 'seller') {
            navigate('/profile');
          }

          // Carica il conteggio nuovi ordini
          const shops = await getShopByOwner(currentUser.uid);
          if (shops.length > 0) {
            const orders = await getShopOrders(shops[0].id);
            const pendingCount = orders.filter(o => o.status === 'pending_confirmation').length;
            setNewOrdersCount(pendingCount);
          }
        } catch (err) {
          console.error('Errore nel caricamento dei dati:', err);
          setError('Errore nel caricamento del profilo');
        } finally {
          setLoading(false);
        }
      } else {
        setLoading(false);
      }
    };

    loadUserData();
  }, [currentUser, navigate]);

  if (loading || authLoading) {
    return (
      <div className="text-center py-5">
        <Spinner animation="border" role="status" />
      </div>
    );
  }

  if (!currentUser || !userProfile) {
    return (
      <div className="d-flex flex-column align-items-center justify-content-center" style={{ minHeight: '60vh' }}>
        <i className="bi bi-shop mb-4" style={{ fontSize: 80, color: '#e0e0e0' }}></i>
        <h4 className="mb-4">Accesso Negato</h4>
        <p className="text-muted mb-4">Questa area è riservata ai venditori</p>
        <Button variant="primary" className="rounded-pill" onClick={() => navigate('/profile')}>
          Torna al Profilo
        </Button>
      </div>
    );
  }

  return (
    <div>
      <Card className="mb-4 rounded-4 shop-card">
        <Card.Body>
          <Row className="align-items-center">
            <Col xs={12}>
              <h4 className="mb-3 fw-bold text-dark">Pannello Venditore</h4>
              <p className="text-muted mb-0">Benvenuto nella tua area venditore</p>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      <ListGroup className="mb-4">
        <ListGroup.Item 
          className="d-flex justify-content-between align-items-center border-0 mb-2 rounded-4 shop-card"
          style={{ cursor: 'pointer' }}
          onClick={() => navigate('/seller/products')}
        >
          <div className="text-dark">
            <i className="bi bi-box me-3 text-primary"></i>
            Gestione Prodotti
          </div>
          <i className="bi bi-chevron-right text-muted"></i>
        </ListGroup.Item>
        
        <ListGroup.Item
          className="d-flex justify-content-between align-items-center border-0 mb-2 rounded-4 shop-card"
          style={{ cursor: 'pointer' }}
          onClick={() => navigate('/seller/orders')}
        >
          <div className="text-dark">
            <i className="bi bi-cart me-3 text-primary"></i>
            Ordini
          </div>
          <div className="d-flex align-items-center gap-2">
            {newOrdersCount > 0 && (
              <Badge bg="danger" pill>
                {newOrdersCount}
              </Badge>
            )}
            <i className="bi bi-chevron-right text-muted"></i>
          </div>
        </ListGroup.Item>
        
        <ListGroup.Item 
          className="d-flex justify-content-between align-items-center border-0 mb-2 rounded-4 shop-card"
          style={{ cursor: 'pointer' }}
          onClick={() => navigate('/seller/settings')}
        >
          <div className="text-dark">
            <i className="bi bi-gear me-3 text-primary"></i>
            Impostazioni Negozio
          </div>
          <i className="bi bi-chevron-right text-muted"></i>
        </ListGroup.Item>

        <ListGroup.Item
          className="d-flex justify-content-between align-items-center border-0 mb-2 rounded-4 shop-card"
          style={{ cursor: 'pointer' }}
          onClick={() => navigate('/seller/shipping')}
        >
          <div className="text-dark">
            <i className="bi bi-truck me-3 text-primary"></i>
            Costi di Spedizione
          </div>
          <i className="bi bi-chevron-right text-muted"></i>
        </ListGroup.Item>

        <ListGroup.Item
          className="d-flex justify-content-between align-items-center border-0 mb-2 rounded-4 shop-card"
          style={{ cursor: 'pointer' }}
          onClick={() => navigate('/seller/payments')}
        >
          <div className="text-dark">
            <i className="bi bi-credit-card me-3 text-primary"></i>
            Metodi di Pagamento
          </div>
          <i className="bi bi-chevron-right text-muted"></i>
        </ListGroup.Item>

        <ListGroup.Item
          className="d-flex justify-content-between align-items-center border-0 mb-2 rounded-4 shop-card"
          style={{ cursor: 'pointer' }}
          onClick={() => navigate('/seller/statistics')}
        >
          <div className="text-dark">
            <i className="bi bi-graph-up me-3 text-primary"></i>
            Statistiche
          </div>
          <i className="bi bi-chevron-right text-muted"></i>
        </ListGroup.Item>
      </ListGroup>
    </div>
  );
};

export default SellerPage; 